import {
  Archive,
  ArchiveRestore,
  ChevronDown,
  Download,
  FileOutput,
  Trash2,
} from "lucide-react";
import { Dropdown } from "../Dropdown";
import { Button } from "../primitives";

interface PrimaryActionsProps {
  selectedCount?: number;
  onBulkDownload?: () => void;
  onBulkDelete?: () => void;
  onBulkArchive?: () => void;
  onBulkUnarchive?: () => void;
  onBulkExport?: () => void;
}

export function PrimaryActions({
  selectedCount = 0,
  onBulkDownload,
  onBulkDelete,
  onBulkArchive,
  onBulkUnarchive,
  onBulkExport,
}: PrimaryActionsProps) {
  if (selectedCount === 0) return null;

  return (
    <Dropdown>
      <Dropdown.Trigger>
        <Button variant="secondary">
          {selectedCount} selected
          <ChevronDown size={14} className="ml-1 -mr-0.5" />
        </Button>
      </Dropdown.Trigger>
      <Dropdown.Content align="end">
        {onBulkArchive && (
          <Dropdown.Item icon={<Archive size={14} />} onSelect={onBulkArchive}>
            Archive
          </Dropdown.Item>
        )}
        {onBulkUnarchive && (
          <Dropdown.Item
            icon={<ArchiveRestore size={14} />}
            onSelect={onBulkUnarchive}
          >
            Unarchive
          </Dropdown.Item>
        )}
        {onBulkExport && (
          <Dropdown.Item
            icon={<FileOutput size={14} />}
            onSelect={onBulkExport}
          >
            Export
          </Dropdown.Item>
        )}
        {onBulkDownload && (
          <Dropdown.Item
            icon={<Download size={14} />}
            onSelect={onBulkDownload}
          >
            Download
          </Dropdown.Item>
        )}
        {(onBulkArchive || onBulkUnarchive || onBulkExport || onBulkDownload) &&
          onBulkDelete && <Dropdown.Separator />}
        {onBulkDelete && (
          <Dropdown.Item
            icon={<Trash2 size={14} />}
            onSelect={onBulkDelete}
            destructive
          >
            Delete
          </Dropdown.Item>
        )}
      </Dropdown.Content>
    </Dropdown>
  );
}
